import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Subscription } from 'rxjs';

import { MatDialog } from '@angular/material/dialog';
import { filter, switchMap, take } from 'rxjs/operators';
import { without } from 'lodash';

import { isNil } from 'lodash';
import { RolesSelectionService } from './role-selection.service';
import { RolesSelectionDialogComponent } from './role-selection-dialog/role-selection-dialog.component';
import { AutoUnsubscribe, DIALOG_DEFAULT_CONFIG, IconNames, Role, ValidationService } from '../../common';
import { PartnersSelectionItem } from '../partners-selection';
import { UserItemFacade, UserOwnerType, UserRolesModel, UserRoleType } from '../../store';
import { ButtonAction, ButtonSize } from '../../ui-kit';

@Component({
  selector: 'container-role-selection',
  templateUrl: './role-selection.component.html',
  styleUrls: ['./role-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class RolesSelectionComponent {
  @Input() isDataEditable: boolean;
  @Input() isMoRProfile: boolean;
  @Input() partners: PartnersSelectionItem[];
  @Input() userOwnerTypeControl: FormControl<UserOwnerType>;
  @Input() set roles(control: Role[] | UserRolesModel) {
    if (control) {
      this.initRolesControl(control);
    }
  }
  buttonAction = ButtonAction;
  buttonSize = ButtonSize;
  subscriptions: Subscription[] = [];
  rolesControl: FormControl<UserRolesModel | Role[]>;
  userOwnerType = UserOwnerType;
  iconNames = IconNames;

  @Output() listChange = new EventEmitter<Role[] | UserRolesModel>();
  constructor(
    public validationService: ValidationService,
    public rolesSelectionService: RolesSelectionService,
    public userItemFacade: UserItemFacade,
    private dialog: MatDialog,
  ) {}

  manageRoles(): void {
    this.userItemFacade.loadAllRoleList(this.userOwnerTypeControl?.value);
    this.subscriptions.push(
      this.userItemFacade.roleList$
        .pipe(
          filter(Boolean),
          take(1),
          switchMap(() => {
            const data: UserRolesModel | Role[] = this.rolesControl.value;
            return this.dialog
              .open(RolesSelectionDialogComponent, {
                data,
                ...DIALOG_DEFAULT_CONFIG,
              })
              .afterClosed();
          }),
        )
        .subscribe((selectedRoles: UserRolesModel) => {
          if (selectedRoles) {
            this.rolesControl.setValue(selectedRoles);
            this.listChange.emit(this.rolesControl.value);
          }
        }),
    );
  }

  removeRole(groupKey: UserRoleType | string, element: string): void {
    const allRolesPreviousValue: UserRolesModel | Role[] = this.rolesControl.value;
    const parentRolesGroupValue: Role[] = allRolesPreviousValue[groupKey] || [];
    const adjustedRoles = without(parentRolesGroupValue, element);
    const rolesControl = {
      ...allRolesPreviousValue,
      [groupKey]: adjustedRoles.length ? adjustedRoles : [],
    };
    const noRoles = Object.values(rolesControl).every(isNil);
    this.rolesControl.reset(noRoles ? [] : rolesControl);
    this.rolesControl.markAsDirty();
    this.listChange.emit(this.rolesControl.value);
  }

  private initRolesControl(roles: Role[] | UserRolesModel): void {
    this.rolesControl = new FormControl<Role[] | UserRolesModel>(roles);
  }
}
